import { createFileRoute, Navigate } from '@tanstack/react-router';
import { pageTitle } from '@/utils/pageTitle';
import { PaymentMethodTable } from '@/components/Pages/PaymentMethods/PaymentMethodTable';
import { CreateEditPaymentMethodModal } from '@/components/Pages/PaymentMethods/CreateEditPaymentMethodModal';
import { Box } from '@mui/joy';
import { useAuth } from '@/contexts/AuthContext';

export const Route = createFileRoute('/_protected/payment-methods')({
  component: PaymentMethodsPage,
  head: () => pageTitle('Métodos de pago'),
});

function PaymentMethodsPage() {
  const { hasClaim, isLoading } = useAuth();
  const canRead = hasClaim('PAYMENT_METHODS_READ');
  const canWrite = hasClaim('PAYMENT_METHODS_WRITE');

  if (!isLoading && !canRead) {
    return <Navigate to='/' />;
  }

  return (
    <Box>
      {canWrite && (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 3 }}>
          <CreateEditPaymentMethodModal />
        </Box>
      )}
      <PaymentMethodTable />
    </Box>
  );
}
